import React, { useContext, useEffect } from 'react';
import loadPianoData from '../piano_pages_state_manager';
import { UserContext } from '../../../components/context/userContext';
import get from 'lodash/get';

const BlankOfferPage = props => {
  const { user, showOffer, activeOffer } = useContext(UserContext);

  const offerId = get(props, 'match.params.offerId', '');
  const templateId = get(props, 'match.params.templateId', '');
  const offerFailed = get(activeOffer, 'failed', false);

  useEffect(() => {
    showOffer(offerId, templateId, 'inline', `.offerContainer`);
  }, user);

  return (
    <React.Fragment>
      <div className="blankOfferPage">
        {offerFailed ? (
          <div key="failContainer" className="errorContainer">
            {get(
              activeOffer,
              'message',
              'Please use an email address ending in .edu.'
            )}
          </div>
        ) : (
          <div className="piano-page-container offer">
            <div className="piano-offer-container" />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

BlankOfferPage.loadData = store => loadPianoData(store);

export default BlankOfferPage;
